import Game from './game';
import '../styles/style.css';

window.game = new Game();